import { Mediator, app, context, payload } from "modular-openscriptjs";
import { eParse, inform, approved, empty } from "../helpers";
import { STRINGS, api, uc, gc } from "../declarations";
import { routes } from "../backendRoutes";

const $e = app("$e");

export class DeliveryAddress extends Mediator {
	
	$$deliveryAddress = {
		needs: {
			storage: (ed, event) => this.storeAddress(ed, event),
			deletion: (ed, event) => this.deleteAddress(ed, event),
			allAddresses: (ed, event) => this.getDeliveryAddresses(),
		},
		selected: (ed, event) => this.selectAddress(ed, event),
	};

	async storeAddress(ed, event) {
		let data = eParse(ed);
		let addressInfo = data.message.getAll();

		for (let key in addressInfo) {
			if (addressInfo[key].length < 1) {
				inform(`${key} is required`, STRINGS.ERROR);

				this.broadcast($e.deliveryAddress.has.storageError, ed);

				return;
			}
		}

		let res = await api.post(routes.deliveryAddress, addressInfo);

		if (!res) this.broadcast($e.deliveryAddress.has.storageError, ed);

		let address = res.data.address;
		context("user").addresses.push(address);

		if (res.data.user) {
			gc.user.value = res.data.user;
		}

		this.broadcast($e.deliveryAddress.stored, ed);
	}

	async selectAddress(ed, event) {
		let data = eParse(ed);
		let address = data.message.address;

		let addresses = [];
		for (let a of context("user").addresses) {
			if (address.id == a.id) continue;
			addresses.push(a);
		}

		addresses.push(address);
		context("user").addresses.value = addresses;

		inform("Address chosen", STRINGS.SUCCESS);

		this.broadcast($e.deliveryAddress.chosen, ed);
	}

	async deleteAddress(ed, event) {
		let data = eParse(ed);

		if (!approved(event, ed, "You want to delete this address")) return;

		let addressId = data.message.id;

		let res = await api.delete(`${routes.deliveryAddress}/${addressId}`);

		if (!res) {
			return this.broadcast($e.deliveryAddress.has.deletionError, ed);
		}

		for (let i in context("user").addresses.value) {
			let a = context("user").addresses.value[i];

			if (a.id == addressId) {
				delete context("user").addresses[i];

				break;
			}
		}

		inform(res.message, STRINGS.SUCCESS);

		return this.broadcast($e.deliveryAddress.deleted, ed);
	}
}
